import { render, staticRenderFns } from "./MovementGuide.vue?vue&type=template&id=0ac1b450&scoped=true&"
import script from "./MovementGuide.vue?vue&type=script&lang=js&"
export * from "./MovementGuide.vue?vue&type=script&lang=js&"
import style0 from "./MovementGuide.vue?vue&type=style&index=0&id=0ac1b450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac1b450",
  null
  
)

export default component.exports